import React from 'react';
import { WebsiteDesignProps } from './types';
import { Building2, ArrowRight, Users, CheckCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";

const CorporateClean: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Corporate Learning";

    return (
        <div className="bg-white min-h-screen font-sans text-slate-800">
            <nav className="border-b border-gray-200 bg-white sticky top-0 z-50">
                <div className="container mx-auto px-6 h-20 flex justify-between items-center">
                    <div className="flex items-center gap-2 text-blue-700 font-bold text-xl">
                        <Building2 /> {schoolName}
                    </div>
                    <div className="hidden md:flex gap-8 text-sm font-medium text-gray-600">
                        <a href="#" className="hover:text-blue-700">Solutions</a>
                        <a href="#" className="hover:text-blue-700">Enterprise</a>
                        <a href="#" className="hover:text-blue-700">Resources</a>
                        <a href="#" className="hover:text-blue-700">Pricing</a>
                    </div>
                    <div className="flex gap-4">
                        <Button variant="ghost" className="text-gray-600 font-medium">Log in</Button>
                        <Button className="bg-blue-700 hover:bg-blue-800 text-white font-medium">Contact Sales</Button>
                    </div>
                </div>
            </nav>

            <header className="bg-slate-50 py-24">
                <div className="container mx-auto px-6 text-center max-w-4xl">
                    <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
                        Enterprise-Grade Education Platform
                    </h1>
                    <p className="text-xl text-slate-600 mb-10 max-w-2xl mx-auto">
                        Scalable, secure, and reliable learning management for the modern organization. Trusted by industry leaders worldwide.
                    </p>
                    <div className="flex justify-center gap-4">
                        <Button className="h-12 px-8 bg-blue-700 hover:bg-blue-800 text-white font-medium text-lg">
                            Get Demo
                        </Button>
                        <Button variant="outline" className="h-12 px-8 border-slate-300 text-slate-700 font-medium text-lg hover:bg-white">
                            View Pricing
                        </Button>
                    </div>
                </div>
            </header>

            <section className="py-20 bg-white">
                <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12">
                    {[
                        { icon: Users, title: "Scalable Teams", desc: "Manage thousands of students with granular permissions and groups." },
                        { icon: CheckCircle, title: "Compliance Ready", desc: "Fully compliant with SOC2, GDPR, and industry standards." },
                        { icon: ArrowRight, title: "Seamless Integration", desc: "Connect with your existing HRIS and CRM tools effortlessly." },
                    ].map((item, i) => (
                        <div key={i} className="flex flex-col items-start p-6 rounded-lg hover:bg-slate-50 transition-colors">
                            <div className="bg-blue-100 p-3 rounded-lg text-blue-700 mb-4">
                                <item.icon size={24} />
                            </div>
                            <h3 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h3>
                            <p className="text-slate-600 leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default CorporateClean;
